import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { useParams, useLocation } from "react-router-dom";
import callAPI from "../Common_Method/api";
import { toast } from "react-toastify";
import { format } from "date-fns";
import axios from "axios";

const Reply = () => {
    const { msg_id, sended_msg_id } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [detail, setDetail] = useState(null);
    const [myresponse, setMyresponse] = useState(null);
    const [error, setError] = useState(null);
    const [replyBodies, setReplyBodies] = useState([]);
    const user = JSON.parse(sessionStorage.getItem("user"));
    const { title, student } = location.state
    const [filePreview, setFilePreview] = useState(null); // Store the file preview URL
    const [uploadedFile, setUploadedFile] = useState(null); // Store the uploaded file link

    const [imagePreview, setImagePreview] = useState(null);
    const [imageURL, setImageURL] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    const handleImageClick = (imageUrl) => {
        setPreviewImage(imageUrl); // Set the clicked image URL
    };

    const closePreview = () => {
        setPreviewImage(null); // Close the preview
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await callAPI.get(
                `./msg/get_single_mst_msg_by_msg_id?msg_id=${msg_id}&sended_msg_id=${sended_msg_id}`
            );
            if (response.data) {
                setDetail(response.data);
                setError(null);
            } else {
                setDetail(null);
                setError("No data available.");
            }
        } catch (error) {
            setDetail(null);
            setError("An error occurred while fetching data.");
        } finally {
            setLoading(false);
        }
    };

    const fetchDataMyresponse = async () => {
        try {
            setLoading(true);
            const response = await callAPI.get(
                `./msg/reply-messages?msg_id=${msg_id}&sended_msg_id=${sended_msg_id}`
            );
            if (response.data) {
                setMyresponse(response.data);
                setError(null);
            } else {
                setMyresponse(null);

            }
        } catch (error) {
            setMyresponse(null);
            setError("An error occurred while fetching data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();// eslint-disable-next-line react-hooks/exhaustive-deps
        fetchDataMyresponse();// eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [msg_id, sended_msg_id]);


    // Function to handle user input changes
    const handleInputChange = (msg_body_id, msg_type, value) => {
        setReplyBodies(prev => {
            const updated = [...prev];
            const index = updated.findIndex(body => body.msg_body_id === msg_body_id);
            if (index !== -1) {
                updated[index].data_reply_text = value;
            } else {
                updated.push({ msg_body_id, msg_type, data_reply_text: value });
            }
            return updated;
        });
    };

    if (loading) {
        return (
            <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return <div className="text-center text-danger">{error}</div>;
    }

    // Divide the msg_body into two equal arrays for rendering
    const midIndex = Math.ceil((detail?.data?.msg_body?.length || 0) / 2);
    const firstColumn = detail?.data?.msg_body?.slice(0, midIndex);
    const secondColumn = detail?.data?.msg_body?.slice(midIndex);

    const parseReplyText = (text) => {
        try {
            return text ? JSON.parse(text) : {};
        } catch (error) {
            return {};
        }
    };

    const renderInputField = (msgBody) => {
        const { msg_type, data_text, msg_body_id, is_reply_required } = msgBody;


        if (msg_type?.startsWith("OPTION")) {
            const handleOptionChange = (selectedValue) => {
                const updatedData = { selected: { 0: selectedValue } };
                handleInputChange(msg_body_id, msg_type, JSON.stringify(updatedData));
                data_text.data_reply_text = JSON.stringify(updatedData);
            };

            return (
                <div>
                    <label className="fw-bolder">
                        {data_text.title} {is_reply_required === 1 ? <span className="text-danger">*</span> : ""}
                    </label>
                    <div className="form-control">
                        {data_text.options.map((option, idx) => (
                            <div key={idx} className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`option-${msg_body_id}`}
                                    id={`option-${msg_body_id}-${idx}`}
                                    value={option.option}
                                    onChange={(e) => handleOptionChange(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor={`option-${msg_body_id}-${idx}`}>
                                    {option.option}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }



        if (msg_type?.startsWith("CHECKBOX")) {
            const parsedText = parseReplyText(data_text.data_reply_text);

            const handleCheckboxChange = (idx, optionValue, isChecked) => {
                let updatedSelected = { ...parsedText.selected };

                if (isChecked) {
                    updatedSelected[idx] = optionValue;
                } else {
                    delete updatedSelected[idx];
                }

                const updatedData = { selected: updatedSelected };
                handleInputChange(msg_body_id, msg_type, JSON.stringify(updatedData));
                data_text.data_reply_text = JSON.stringify(updatedData);
            };

            return (
                <div>
                    <label className="fw-bolder">
                        {data_text.title}
                        {is_reply_required === 1 ? <span className="text-danger">*</span> : ''}
                    </label>
                    {data_text.options.map((option, idx) => {
                        const isChecked = parsedText.selected?.[idx] !== undefined;
                        return (
                            <div key={idx} className="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    id={`option-${idx}`}
                                    checked={isChecked}
                                    onChange={e => handleCheckboxChange(idx, option.option, e.target.checked)}
                                />
                                {/* Label is now just a span, not clickable */}
                                <span className="ms-2">{option.option}</span>
                            </div>
                        );
                    })}
                </div>
            );
        }



        // Handle TEXTBOX type (single-line input)
        if (msg_type?.startsWith("TEXTBOX")) {
            const parsedText = parseReplyText(data_text.data_reply_text);

            const handleTextboxChange = (e) => {
                const updatedData = { text: e.target.value };
                handleInputChange(msg_body_id, msg_type, JSON.stringify(updatedData));
                data_text.data_reply_text = JSON.stringify(updatedData);
            };

            return (
                <div>
                    <label className="fw-bolder">{data_text.title}{is_reply_required === 1 ? <span className="text-danger">*</span> : ''}</label>
                    <input
                        type="text"
                        className="form-control"
                        value={parsedText.text || ""}
                        onChange={handleTextboxChange}
                    />
                </div>
            );
        }

        // Handle TEXTAREA type (multi-line input)
        if (msg_type?.startsWith("TEXTAREA")) {
            const parsedText = parseReplyText(data_text.data_reply_text);

            const handleTextareaChange = (e) => {
                const updatedData = { text: e.target.value };
                handleInputChange(msg_body_id, msg_type, JSON.stringify(updatedData));
                data_text.data_reply_text = JSON.stringify(updatedData);
            };

            return (
                <div>
                    <label className="fw-bolder">{data_text.title}{is_reply_required === 1 ? <span className="text-danger">*</span> : ''}</label>
                    <textarea
                        className="form-control"
                        value={parsedText.text || ""}
                        onChange={handleTextareaChange}
                    />
                </div>
            );
        }

        // Handling CAMERA type (file input for image capture)
        if (msg_type?.startsWith("CAMERA")) {


            const handleCameraChange = async (e) => {
                const file = e.target.files[0];
                if (file) {
                    try {
                        // Set the preview of the image immediately
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            setImagePreview(reader.result);
                        };
                        reader.readAsDataURL(file);

                        // Prepare the form data for the image upload
                        const formData = new FormData();
                        formData.append("file", file);

                        const response = await axios.post(
                            "https://apps.actindore.com/api/v1/admin/imageUpload_Use/imageUpload",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );

                        const imageLink = response?.data?.url;


                        // Save the uploaded image link to state
                        setImageURL(imageLink);

                        handleInputChange(msg_body_id, msg_type, JSON.stringify({ imageURIsave: imageLink }));
                    } catch (error) {
                        console.error("Error uploading file:", error);
                        alert("Failed to upload the file. Please try again.");
                    }
                }
            };

            const handleRemoveImage = () => {
                setImagePreview(null);
                setImageURL(null);
                handleInputChange(msg_body_id, msg_type, JSON.stringify({ imageURIsave: null }));
            };

            return (
                <div className="mt-3">
                    <label className="fw-bolder">
                        {data_text.title || "Camera Input"}
                        {is_reply_required === 1 ? <span className="text-danger">*</span> : ''}
                    </label>
                    <div className="form-control p-3">
                        <div className="row">
                            <div className="col"></div>
                            <div className="col text-end">
                                <button className="btn bg-FF0000 position-relative rounded-3 mb-2">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="camera"
                                        className="form-control"
                                        onChange={handleCameraChange}
                                    />
                                    <span className="text-white">
                                        <i className="fa-solid fa-camera me-2"></i>
                                        Add Image
                                    </span>
                                </button>

                                {/* Preview the image if available */}
                                {imagePreview && (
                                    <div className="mt-3">
                                        <img src={imagePreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                    </div>
                                )}

                                {/* Remove Image Button */}
                                {imagePreview && (
                                    <button
                                        className="btn bg-FF0000 position-relative rounded-3 mt-2"
                                        onClick={handleRemoveImage}
                                    >
                                        <span className="text-white">
                                            <i className="fa-solid fa-trash me-2"></i>
                                            Remove Image
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        // Handling FILE type (file upload)
        if (msg_type?.startsWith("FILE")) {
            const getFileIcon = (fileName) => {
                const extension = fileName.split('.').pop().toLowerCase();
                switch (extension) {
                    case 'pdf':
                        return 'fa-file-pdf'; // PDF icon
                    case 'doc':
                    case 'docx':
                        return 'fa-file-word'; // Word icon
                    case 'xls':
                    case 'xlsx':
                        return 'fa-file-excel'; // Excel icon
                    default:
                        return 'fa-file'; // Default file icon for unknown file types
                }
            };

            const handleFileChange = async (e) => {
                const file = e.target.files[0];
                if (file) {
                    try {
                        // Set the file preview URL (or icon based on the file type)
                        setFilePreview(URL.createObjectURL(file));

                        const formData = new FormData();
                        formData.append("file", file); // The key "file" should match the API's expected field name

                        const response = await axios.post(
                            "https://apps.actindore.com/api/v1/admin/pdfUpload_Use/pdfUpload",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );

                        const fileLink = response?.data?.url; // Assuming API returns the link in `data.url`

                        setUploadedFile(fileLink); // Store the uploaded file URL
                        handleInputChange(msg_body_id, msg_type, JSON.stringify({ imageURIsave: fileLink }));
                    } catch (error) {
                        console.error("Error uploading file:", error);
                        alert("Failed to upload the file. Please try again.");
                    }
                }
            };

            const handleRemoveFile = () => {
                setFilePreview(null); // Remove the file preview
                setUploadedFile(null); // Reset the uploaded file link
            };

            return (
                <div className="mt-3">
                    <label className="fw-bolder">Upload File{is_reply_required === 1 ? <span className="text-danger">*</span> : ''}</label>
                    <div className="form-control p-3">
                        <div className="row">
                            <div className="col-6">
                                {/* File preview: Show an icon or text based on file type */}
                                {filePreview && (
                                    <div className="file-preview text-center">
                                        {filePreview && !filePreview.startsWith("data:image") ? (
                                            <i className={`fa ${getFileIcon(filePreview)} fa-5x`}></i> // Document icon
                                        ) : (
                                            <img src={filePreview} alt="File preview" className="img-fluid" /> // Image preview
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="col-6 text-end">
                                <button className="btn bg-FF0000 position-relative rounded-3 mb-2">
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={handleFileChange}
                                    />
                                    <span className="text-white">
                                        <i className="fa-solid fa-paperclip me-2"></i>
                                        Add File
                                    </span>
                                </button>
                                <br />
                                {uploadedFile && (
                                    <button
                                        className="btn bg-FF0000 position-relative rounded-3 mt-2"
                                        onClick={handleRemoveFile}
                                    >
                                        <span className="text-white">
                                            <i className="fa-solid fa-trash me-2"></i>
                                            Remove File
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        // For other message types, display content without input handling
        if (msg_type?.startsWith("YOUTUBE")) {
            if (!data_text.link) {
                // If the link is blank, return a fallback message or UI
                return <p className="text-muted">No YouTube link provided.</p>;
            }
            try {
                const videoId = new URLSearchParams(new URL(data_text.link).search).get("v");
                if (!videoId) {
                    // If the link is invalid or doesn't contain a valid video ID
                    return <p className="text-muted">Invalid YouTube link.</p>;
                }
                const embedUrl = `https://www.youtube.com/embed/${videoId}`;
                return (
                    <>
                        {data_text?.title && <label className="fw-bolder">{data_text.title}</label>}
                        <iframe
                            src={embedUrl}
                            title="YouTube Video"
                            width="100%"
                            height="300"
                            style={{ border: "none" }}
                            allowFullScreen
                        ></iframe>
                    </>

                );
            } catch (error) {
                // If the link is not a valid URL
                return <p className="text-muted">Invalid YouTube link format.</p>;
            }
        }


        if (msg_type?.startsWith("IMAGE")) {
            return (
                <>
                    {data_text?.title && <label className="fw-bolder">{data_text.title}</label>}
                    <img
                        src={data_text.link}
                        alt="Message Content"
                        className="img-fluid rounded-3 w-100"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleImageClick(data_text.link)}
                    />
                    {/* Modal for Image Preview */}
                    {previewImage && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            }}
                            onClick={closePreview}
                        >
                            <img
                                src={previewImage}
                                alt="Full Preview"
                                style={{
                                    maxHeight: "90%",
                                    maxWidth: "90%",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                }}
                            />
                        </div>
                    )}
                </>
            );
        }

        // ✅ PDF Display
        if (msg_type?.startsWith("PDF")) {
            return (
                <>
                    {data_text?.title && (
                        <label className="fw-bolder">{data_text.title}</label>
                    )}

                    <div className="card p-3 shadow-sm border-0">
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <i className="fa-solid fa-file-pdf text-danger fs-2 me-2"></i>
                                <span className="fw-semibold">PDF Document</span>
                            </div>

                            <a
                                href={data_text.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-primary"
                            >
                                View PDF
                            </a>
                        </div>

                        <div className="mt-2">
                            <iframe
                                src={data_text.link}
                                width="100%"
                                height="350"
                                style={{ border: "1px solid #ddd", borderRadius: "8px" }}
                                title="PDF Preview"
                            ></iframe>
                        </div>
                    </div>
                </>
            );
        }


        return (
            <>
                {data_text?.title && <label className="fw-bolder">{data_text.title}</label>}
                {data_text?.text && <p dangerouslySetInnerHTML={{ __html: data_text.text }}></p>}
                {data_text?.link && !msg_type?.startsWith("PDF") && (
                    <div>
                        <a
                            href={data_text.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-link text-start"
                        >
                            {data_text.link}
                        </a>
                    </div>
                )}

                {data_text?.options && (
                    <div>
                        <label className="fw-bolder">{data_text.title}</label>
                        <ul className="list-group">
                            {data_text.options?.map((option, idx) => (
                                <li key={idx} className="list-group-item">
                                    {option.option}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </>
        );
    };

    const handleReply = async () => {
        // Check required fields
        const missingFields = [];

        detail?.data?.msg_body?.forEach((msgBody) => {
            if (msgBody.is_reply_required === 1) {
                const response = replyBodies.find(rb => rb.msg_body_id === msgBody.msg_body_id);
                if (!response) {
                    missingFields.push(msgBody.label);
                    return;
                }

                // Check based on type
                const data = parseReplyText(response.data_reply_text);

                if (
                    (msgBody.msg_type.startsWith("TEXTBOX") || msgBody.msg_type.startsWith("TEXTAREA")) &&
                    (!data.text || data.text.trim() === "")
                ) {
                    missingFields.push(msgBody.label);
                }

                if (
                    msgBody.msg_type.startsWith("OPTION") &&
                    (!data.selected || Object.keys(data.selected).length === 0)
                ) {
                    missingFields.push(msgBody.label);
                }

                if (
                    msgBody.msg_type.startsWith("CHECKBOX") &&
                    (!data.selected || Object.keys(data.selected).length === 0)
                ) {
                    missingFields.push(msgBody.label);
                }

                if (
                    (msgBody.msg_type.startsWith("CAMERA") || msgBody.msg_type.startsWith("FILE")) &&
                    (!data.imageURIsave || data.imageURIsave === null)
                ) {
                    missingFields.push(msgBody.label);
                }
            }
        });

        if (missingFields.length > 0) {
            alert(`Please fill/select required fields: ${missingFields.join(", ")}`);
            return; // Stop submission
        }

        // Proceed if all required fields are filled
        const payload = {
            msg_id: parseInt(msg_id),
            mobile_no: parseInt(user?.mobile_no),
            student_main_id: parseInt(student?.student_number),
            sended_msg_id: parseInt(sended_msg_id),
            student_number: student?.student_number,
            replyBodies: replyBodies,
        };

        try {
            const response = await callAPI.post(
                "https://apps.actindore.com/api/msg/insertRepliedMessageAndBodies",
                payload
            );
            if (response.data) {
                toast.success("Reply sent successfully!");
                fetchData();
                fetchDataMyresponse();
            }
        } catch (error) {
            console.error("Error sending reply:", error.message);
            toast.error("Failed to send reply.");
        }
    };



    const getResponseForMsgBody = (msgBodyId) => {
        return myresponse?.data?.replyBodies?.find(
            (resp) => resp.msg_body_id === msgBodyId
        );
    };


    return (
        <>
            <Header />
            <div className="container-fluid p-0 reply-page">
                <div className="idname py-1 border-bottom">
                    <div className="container py-1">
                        <h6 className="text-1F2C37 fw-bolder mb-0">
                            {detail?.data?.msg_detail?.subject_text}
                        </h6>
                        {/* <h6 className="text-secondary fw-normal mb-0">
                            Show Up to : {format(new Date(detail?.data?.msg_detail?.show_upto), "dd-MMM-yyyy  hh:mm a")}
                        </h6> */}
                        <h6 className="text-secondary fw-normal mb-0">
                            Show Up to :{" "}
                            {detail?.data?.msg_detail?.show_upto
                                ? format(new Date(detail.data.msg_detail.show_upto), "dd-MMM-yyyy hh:mm a")
                                : "N/A"}
                        </h6>
                    </div>
                </div>

                <div className="container my-3">


                    <div className="row">
                        {detail?.data?.msg_body?.map((msgBody, index) => {
                            const response = getResponseForMsgBody(msgBody.msg_body_id);
                            let parsedData = {};

                            try {
                                parsedData = response ? JSON.parse(response.data_reply_text) : {};
                            } catch (e) {
                                console.error("JSON parse error for response:", response, e);
                            }

                            const renderSelected = (selected) => {
                                if (!selected) return "No selection";
                                return Object.values(selected).join(", ");
                            };

                            return (
                                <div key={index} className="col-xl-6 col-lg-6 col-12 mb-3">
                                    <div className="card px-3 py-4 border-0 rounded-4 shadow-sm">
                                        <h6 className="fw-bold mb-2">{msgBody.label}</h6>
                                        {renderInputField(msgBody)}

                                        {response && (
                                            <div className="mt-3 border-top pt-2">
                                                <h6 className="fw-semibold text-primary">My Response</h6>

                                                {/* Option / Checkbox */}
                                                {response.msg_type.includes("OPTION") && <p>{renderSelected(parsedData?.selected)}</p>}
                                                {response.msg_type.includes("CHECKBOX") && <p>{renderSelected(parsedData?.selected)}</p>}

                                                {/* Textbox / Textarea */}
                                                {response.msg_type.includes("TEXTBOX") && <p>{parsedData?.text || "No text entered"}</p>}
                                                {response.msg_type.includes("TEXTAREA") && <p>{parsedData?.text || "No text entered"}</p>}

                                                {/* Camera */}
                                                {response.msg_type.includes("CAMERA") && parsedData?.imageURIsave && (
                                                    <img
                                                        src={parsedData.imageURIsave}
                                                        alt="User response"
                                                        className="img-fluid rounded"
                                                        style={{ maxWidth: "200px" }}
                                                    />
                                                )}

                                                {/* File */}
                                                {response.msg_type.includes("FILE") && parsedData?.imageURIsave && (
                                                    <a
                                                        href={parsedData.imageURIsave}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-outline-primary btn-sm"
                                                    >
                                                        Download File
                                                    </a>
                                                )}

                                                {/* Generic fallback */}
                                                {!["OPTION", "CHECKBOX", "TEXTBOX", "TEXTAREA", "CAMERA", "FILE"].some(type => response.msg_type.includes(type)) && (
                                                    <p>{renderSelected(parsedData?.selected) || parsedData?.text || "No response"}</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        <div className="col-12 mt-3">
                            {detail?.data?.msg_detail?.is_reply_required_any === 1 && (
                                <button
                                    className={`btn border-0 text-white rounded-5 ${detail?.data?.is_reply_done === 1 ? "bg-secondary" : "bg-FF0000"}`}
                                    onClick={detail?.data?.is_reply_done === 1 ? undefined : handleReply}
                                    disabled={detail?.data?.is_reply_done === 1}
                                >
                                    {detail?.data?.is_reply_done === 1 ? "Reply Sent" : "Send Reply"}
                                </button>
                            )}
                        </div>
                    </div>


                </div>
            </div>
        </>
    );
};


export default Reply;